import { useI18n } from '@change-corgi/core/react/i18n';

export const OG_IMAGE = 'https://static.change.org/brand-pages/about/opengraph-about.jpg';

type Result = ModelHookResult<{
	title: string;
	description: string;
	image: string;
}>;

export function usePageMeta(): Result {
	const { translate } = useI18n();

	const title = translate('fe.pages.about_team.title');
	const description = translate('fe.pages.about_team.description');

	return {
		data: {
			title,
			description,
			image: OG_IMAGE,
		},
	};
}
